import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import DataTable from "../../components/DataTable/DataTable";
import { fetchCarrierEsims } from "../../services/esimService";

export default function MyEsims() {
  const columns = [
    // TYLKO pola z backendu
    { key: "iccid", label: "ICCID" },
    { key: "user_id", label: "User ID" },
    { key: "country_name", label: "Country" },
    { key: "region_name", label: "Region" },
    { key: "status", label: "Status" },
    { key: "installed", label: "Installed" },
    { key: "data_left", label: "Data Left (MB)" },
    { key: "data_limit", label: "Data Limit (MB)" },
    { key: "data_usage", label: "Used (MB)" },
    { key: "top_up_type", label: "Top-up" },
    { key: "automatic_topup", label: "Auto Top-up" },
  ];

  const optionalColumns = [
    // TYLKO pola z backendu
    { key: "imsi", label: "IMSI" },
    { key: "activation_code", label: "Activation" },
    { key: "country_id", label: "Country ID" },
    { key: "region_id", label: "Region ID" },
    { key: "qr_url", label: "QR" },
    { key: "updated_at", label: "Updated" },
    { key: "created_at", label: "Created" },
    { key: "purchased_at", label: "Purchased" },
    { key: "activate_before", label: "Activate Before" },
  ];

  const sortOptions = [
    // TYLKO pola z backendu (sortable)
    { value: "iccid", label: "ICCID" },
    { value: "imsi", label: "IMSI" },
    { value: "status", label: "Status" },
    { value: "installed", label: "Installed" },
    { value: "data_left", label: "Data Left" },
    { value: "data_limit", label: "Data Limit" },
    { value: "data_usage", label: "Data Usage" },
    { value: "created_at", label: "Created" },
    { value: "updated_at", label: "Updated" },
    { value: "purchased_at", label: "Purchased" },
    { value: "activate_before", label: "Activate Before" },
    { value: "top_up_type", label: "Top-up Type" },
  ];

  const filterDefinitions = [
    // TYLKO z API docs
    { key: "iccid", type: "text" },
    { key: "imsi", type: "text" },
    { key: "activation_code", type: "text" },
    {
      key: "status",
      type: "select",
      options: [
        { value: "inactive", label: "Inactive" },
        { value: "active", label: "Active" },
        { value: "terminated", label: "Terminated" },
      ],
    },
    {
      key: "installed",
      type: "select",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    { key: "country_name", type: "text" },
    { key: "region_name", type: "text" },
    {
      key: "updated_at",
      type: "date-range",
      minKey: "min_updated_at",
      maxKey: "max_updated_at",
    },
    {
      key: "purchased_at",
      type: "date-range",
      minKey: "min_purchased_at",
      maxKey: "max_purchased_at",
    },
  ];

  const customRenderers = {
    installed: (item) => (item.installed ? "Yes" : "No"),
    status: (item) =>
      item.status?.charAt(0).toUpperCase() + item.status?.slice(1) || "-",
    automatic_topup: (item) => (item.automatic_topup ? "Auto" : "Manual"),
    top_up_type: (item) => (item.top_up_type ? `${item.top_up_type}` : "-"),

    // Liczby MB
    data_left: (item) =>
      item.data_left ? `${Math.round(item.data_left)} MB` : "-",
    data_limit: (item) =>
      item.data_limit ? `${Math.round(item.data_limit)} MB` : "-",
    data_usage: (item) =>
      item.data_usage ? `${Math.round(item.data_usage)} MB` : "-",

    // Daty lokalne (PL)
    created_at: (item) =>
      item.created_at ? new Date(item.created_at).toLocaleString("pl-PL") : "-",
    updated_at: (item) =>
      item.updated_at ? new Date(item.updated_at).toLocaleString("pl-PL") : "-",
    purchased_at: (item) =>
      item.purchased_at
        ? new Date(item.purchased_at).toLocaleString("pl-PL")
        : "-",
    activate_before: (item) =>
      item.activate_before
        ? new Date(item.activate_before).toLocaleString("pl-PL")
        : "-",
  };

  return (
    <main className="myesims-page">
      <Helmet>
        <title>My eSIMs - GlobTel</title>
      </Helmet>
      <header className="partner-offers__hero">
        <h1>My eSIMs</h1>
        <p className="partner-offers__lead">
          View and manage your carrier eSIM stats and usage.
        </p>
      </header>

      <DataTable
        fetchDataFunction={fetchCarrierEsims}
        columns={columns}
        optionalColumns={optionalColumns}
        sortOptions={sortOptions}
        filterDefinitions={filterDefinitions}
        defaultSortBy="created_at"
        itemKey="iccid"
        customRenderers={customRenderers}
        showCheckboxes={false}
        storageKey="myEsimsTableFilters"
      />
    </main>
  );
}
